module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticStyle: {
      "height": "380px",
      "width": "100%"
    },
    attrs: {
      "id": _vm.variableTreeDivId
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticStyle: {
      "height": "380px",
      "overflow": "auto"
    },
    attrs: {
      "id": _vm.tableDivId
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.selectedVariable) ? _c('div', {
    staticStyle: {
      "height": "45px",
      "width": "100%"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.selectedVariable.name) + " ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.selectedVariable.description) + " ")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeButtonClick
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "disabled": !_vm.pendingChanges
    },
    on: {
      "click": function($event) {
        return _vm.saveButtonClick()
      }
    }
  }, [_vm._v("Save")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3296adb2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3296adb2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/edit-node-data-dialog/edit-node-data-dialog.vue.html
// module id = 1092
// module chunks = 0